<template>
    <div class="system-info-bar">
        <div class="system-info-bar__inner wrapper-x-40">
            <a
                class="system-info-bar__link"
                href="http://kpam3d.ru"
                target="_blank"
            >
                KPam-3D v {{ version?.current_version_number }} — ©
                {{ currentYear }}
            </a>
            <span class="system-info-bar__text">{{ systemInfoText }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "SystemInfoBar",
    computed: {
        version() {
            return this.$store.state.versions.version;
        },
        currentYear() {
            return new Date().getFullYear();
        },
        systemInfoText() {
            const raw = this.$t("admin.sidebar.system_info");
            return String(raw)
                .replace(/<[^>]*>/g, " ")
                .replace(/\s+/g, " ")
                .trim();
        },
    },
};
</script>

<style scoped>
.system-info-bar {
    position: fixed;
    left: 55px;
    right: 0;
    bottom: 0;
    height: 28px;
    background-color: #fff;
    border-top: 1px solid #cfe2e8;
    z-index: 80;
}
.system-info-bar__inner {
    height: 100%;
    display: flex;
    align-items: center;
    gap: 18px;
    font-size: 12px;
    color: #9ca3af;
    overflow: hidden;
    white-space: nowrap;
}
.system-info-bar__link {
    color: #9ca3af;
    text-decoration: none;
}
.system-info-bar__link:hover {
    text-decoration: underline;
}
.system-info-bar__text {
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
